/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Sidebar, tituloBase } from "../../../../shared";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Column } from "primereact/column";
import { Divider } from "primereact/divider";
import { ConfirmDialog } from "primereact/confirmdialog";
import {
  Boton,
  Titulo,
  Formulario,
  CampoInformacion,
  accessAPI,
  TablaFiltrable
} from "../../../../shared";
import AsignarCertificadoTipo from "./AsignarCertificadoTipo";
import FlujoPasos from "./FlujoPasos";

export default function ActividadTipo() {
  const [loader, setLoader] = useState(true);
  const [actividadTipo, setActividadTipo] = useState();
  const [pasos, setPasos] = useState([]);

  // Sidebar de editar detalles
  const [sideBarDetalles, setSideBarDetalles] = useState(false);
  const [loaderDetalles, setLoaderDetalles] = useState(false);

  const toast = useRef(null);
  const navigate = useNavigate();
  const { actividadTipoId } = useParams();

  // Configuración del formulario de edición de detalles
  const editarDetallesFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "nombre",
            tipoitemformularioid: 1,
            etiqueta: "Nombre",
            requerido: true,
            respuesta: actividadTipo?.nombre
          },
          {
            nombre: "disponible",
            tipoitemformularioid: 6,
            etiqueta: "Disponible",
            respuesta: actividadTipo?.disponible
          },
          {
            nombre: "disponiblesolicitud",
            tipoitemformularioid: 6,
            etiqueta: "Disponible para solicitudes de clientes",
            respuesta: actividadTipo?.disponiblesolicitud
          },
          {
            nombre: "correspondeemision",
            tipoitemformularioid: 6,
            etiqueta: "Corresponde emisión de certificado",
            respuesta: actividadTipo?.correspondeemision
          },
          {
            nombre: "instruccionesAlAsistente",
            tipoitemformularioid: 11,
            etiqueta: "Instrucciones para el asistente de IA",
            respuesta: actividadTipo?.instruccionesAlAsistente
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Guardar",
        callback: guardarDetalles,
        validar: true
      }
    ]
  };

  function guardarDetalles(camposFormulario) {
    setLoaderDetalles(true);
    accessAPI(
      "PUT",
      `admin/actividad/tipoactividad/${actividadTipoId}`,
      camposFormulario,
      () => {
        cargarActividadTipo();
        document.title = camposFormulario.nombre;
        setLoaderDetalles(false);
        setSideBarDetalles(false);
        toast.current?.show({
          severity: "success",
          summary: "Actualizado",
          detail: "Detalles actualizados correctamente",
          life: 3000
        });
      },
      (respuesta) => {
        setLoaderDetalles(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al actualizar",
          sticky: true
        });
      }
    );
  }

  function cargarActividadTipo() {
    accessAPI(
      "GET",
      `admin/actividad/actividadTipo/${actividadTipoId}`,
      null,
      (respuesta) => {
        setActividadTipo(respuesta);
        document.title = respuesta.nombre;
        setPasos(respuesta.actividadpasoconfig || []);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar tipo de actividad",
          sticky: true
        });
      }
    );
  }

  // Cuando carga el componente va a buscar el tipo de actividad
  useEffect(() => {
    cargarActividadTipo();
    return () => (document.title = tituloBase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <ConfirmDialog />

      {/* Sidebar editar detalles */}
      <Sidebar
        visible={sideBarDetalles}
        onHide={() => setSideBarDetalles(false)}
        position="right"
        closeIcon={
          <div>
            <i className="pi pi-times"></i>
          </div>
        }
        className="w-full lg:w-30rem md:w-30rem"
      >
        <div css={{ marginBottom: "50px" }}>
          <Titulo>Editar detalles</Titulo>
          {actividadTipo && (
            <Formulario
              key={`detalles-${sideBarDetalles}`}
              config={editarDetallesFormConfig}
              loader={loaderDetalles}
            />
          )}
        </div>
      </Sidebar>

      {loader && (
        <div css={{ marginTop: "2em", display: "flex", flexDirection: "column", gap: "1em" }}>
          <div css={{ display: "flex", alignItems: "center", gap: "1em" }}>
            <Skeleton width="2rem" height="2rem" shape="circle" />
            <Skeleton width="16rem" height="2rem" />
          </div>
          <Card>
            <Skeleton width="6rem" height="1.5rem" css={{ marginBottom: "1em" }} />
            <div className="grid">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="col-12 md:col-4">
                  <Skeleton width="50%" height="0.8rem" css={{ marginBottom: "0.5rem" }} />
                  <Skeleton width="80%" height="1.2rem" />
                </div>
              ))}
            </div>
          </Card>
          <div className="grid">
            <div className="col-12 lg:col-6">
              <Card>
                <Skeleton width="6rem" height="1.5rem" css={{ marginBottom: "1em" }} />
                <Skeleton width="100%" height="3rem" css={{ marginBottom: "0.3rem" }} />
                <Skeleton width="100%" height="3rem" css={{ marginBottom: "0.3rem" }} />
                <Skeleton width="100%" height="3rem" />
              </Card>
            </div>
            <div className="col-12 lg:col-6">
              <Card>
                <Skeleton width="10rem" height="1.5rem" css={{ marginBottom: "1em" }} />
                <Skeleton width="100%" height="3rem" css={{ marginBottom: "0.3rem" }} />
                <Skeleton width="100%" height="3rem" css={{ marginBottom: "0.3rem" }} />
                <Skeleton width="100%" height="3rem" />
              </Card>
            </div>
          </div>
        </div>
      )}

      {!loader && actividadTipo && (
        <div>
          <Titulo urlVolver="/actividades/tipos">{actividadTipo.nombre}</Titulo>

          {/* Card de detalles */}
          <Card css={{ marginBottom: "1em" }}>
            <Titulo
              botones={
                <Boton
                  callback={() => setSideBarDetalles(true)}
                  texto
                  icono
                  chico
                  negro
                >
                  <i className="pi pi-pencil"></i>
                </Boton>
              }
            >
              Detalles
            </Titulo>
            <div className="grid">
              <CampoInformacion nombreCampo="Nombre">
                {actividadTipo.nombre}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Disponible">
                {actividadTipo.disponible ? "Sí" : "No"}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Disponible para solicitudes">
                {actividadTipo.disponiblesolicitud ? "Sí" : "No"}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Corresponde emisión">
                {actividadTipo.correspondeemision ? "Sí" : "No"}
              </CampoInformacion>
            </div>
            <Divider />
            <div className="grid">
              <CampoInformacion
                nombreCampo="Instrucciones para el asistente de IA"
                anchoCompleto
              >
                <span css={{ whiteSpace: "pre-wrap" }}>
                  {actividadTipo.instruccionesAlAsistente || "-"}
                </span>
              </CampoInformacion>
            </div>
          </Card>

          {/* Pasos y flujo: una sola card con el flujograma */}
          <Card css={{ marginBottom: "1em" }}>
            <FlujoPasos
              actividadTipoId={actividadTipoId}
              // Los pasos guardados cambiaron: los usa la card de tipos de
              // certificado
              onGuardado={cargarActividadTipo}
              toast={toast}
            />
          </Card>

          <div className="grid">
            <div className="col-12 lg:col-6">
              {/* Card de actividades abiertas */}
              {actividadTipo.actividad?.length > 0 && (
                <Card>
                  <Titulo>Actividades abiertas</Titulo>
                  <TablaFiltrable conFiltros={false}
                    value={actividadTipo.actividad}
                    nombreArchivo="actividades_abiertas"
                    size="small"
                    emptyMessage="No hay actividades abiertas"
                    paginator
                    rows={10}
                    selectionMode="single"
                    onRowSelect={(e) => {
                      const url = `/proceso/${e.data.proceso.id}/actividades/${e.data.id}?volver=/actividades/tipos/${actividadTipoId}`;
                      if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
                        window.open(url, "_blank");
                      } else {
                        navigate(url);
                      }
                    }}
                    rowHover
                  >
                    <Column
                      header="Proceso"
                      body={(rowData) => rowData.proceso.nombre}
                    />
                    <Column
                      header="Paso actual"
                      body={(rowData) =>
                        // Más de uno si la actividad tiene pasos en paralelo
                        (rowData.actividadpaso || [])
                          .map((paso) => paso.nombre)
                          .filter(Boolean)
                          .join(", ") || "—"
                      }
                    />
                  </TablaFiltrable>
                </Card>
              )}
            </div>
            <div className="col-12 lg:col-6">
              {/* Card de tipos de certificado */}
              <Card>
                <AsignarCertificadoTipo actividadTipo={actividadTipo} pasos={pasos} />
              </Card>
            </div>
          </div>

        </div>
      )}
    </>
  );
}
